// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2f6Pf","fullView":"styles_fullView__FjgWV"};